import { Container, Divider, Heading } from "@chakra-ui/react";
import CardForm from "components/ui/CardForm";
import HeaderBarInternal from "components/ui/HeaderBarInternal";
import ThemeForm from "../components/ThemeForm";

export default function PageCreateTheme() {
  return (
    <>
      <HeaderBarInternal title="Novo tema" backTo="/temas" />
      <Divider />

      <Container variant="internal" flexDirection="column">
        <Heading as="h1" size="h1">
          Dados do tema
          <span>Identifique um novo tema Patri</span>
        </Heading>

        <CardForm>
          <ThemeForm />
        </CardForm>
      </Container>
    </>
  );
}
